<div class="modalShareProfile">
  <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
  </div>
  <div class="modalShareProfileContent">
      <div class="title">{{'shareYourProfile' | translate}}
      </div>
      <span class="description" [innerHTML]="'shareYourProfileDescription' | translate"></span>
      <ion-button expand="block" class="button-edit-profile-share" shape="round" (click)="triggerShare()">
          <ion-icon name="share-social" class="button-edit-profile-share-icon"></ion-icon>
          {{'share' | translate}}
      </ion-button>   
  </div>
</div>